module.exports = __webpack_public_path__ + "static/media/bron2.985f763d.jpg";